import ModelUpdate from "@/models/ModelUpdate";
import {IGlobalConfigAdmin} from "@/models/global-config/GlobalConfigAdminModels";
import {ValidationRule} from "@/declarations/ValidationRule";

export default class GlobalConfigUpdateMinimumOrderSurcharge extends ModelUpdate<IGlobalConfigAdmin> {

	public amount!: number | null;
	public untilAmount!: number | null;

	public constructor(model: IGlobalConfigAdmin) {
		super();
		this.setDetailModel(model);
	}

	protected initializeWithDetailModelData(detailModel: IGlobalConfigAdmin): void {
		this.amount = detailModel.minimumOrderSurchargeAmount?.amount ?? null;
		this.untilAmount = detailModel.minimumOrderSurchargeUntilAmount?.amount ?? null;
	}

	public rules(): ValidationRule[] {
		return [];
	}

}
